<template>
  <b-container v-if="shipping_costs_context_loaded" fluid class="px-2">
    <info-icon class="m-0 mb-2" info="Duplo clique no pedido para ir no pedido"/>
    <b-row id="shipping-costs-table">
      <b-col v-for="(obj, i) in ShippingCostsObject" :key="'shipping-costs-' + i" lg="4" md="12" class="mb-4">
        <div class="white-box px-2">
          <b-row :class="'shipping-table-header table-header mb-2 ' + obj.bg">
            <b-col class="text-base" style="text-align: center;">
              <span style="color: white" class="d-inline-block align-middle">{{ obj.title }}</span>
            </b-col>
          </b-row>
          <b-row class="m-0">
            <b-table
                :id="'shipping-table-' + i"
                class="text-base text-12"
                style="color: #666666;"
                :items="obj.info"
                :fields="fields"
                @row-dblclicked="onShippingRowDoubleClicked"
                head-variant="light" striped hover fixed>
              <template v-slot:cell(show_details)="row">
                <img src="@/assets/abc_curve/eye.png" width="24" @click="row.toggleDetails"
                    class="text-base text-12 shipping-table-details-color mr-2"
                    :style="obj.img_color">
              </template>

              <template v-slot:row-details="row">
                <b-card>
                  <b-row>
                    <b-col align-self="center">
                      <b-row class="mb-2">
                        <b>Pedido:</b>&nbsp;{{ row.item.order_id }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Valor do pedido:</b>&nbsp;{{ row.item.order_value }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Cliente:</b>&nbsp;{{ row.item.customer }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Frete inicial:</b>&nbsp;{{ row.item.initial_cost }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Frete final:</b>&nbsp;{{ row.item.final_cost }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Nome da transportadora:</b>&nbsp;{{ row.item.shipper_name }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Nome do frete:</b>&nbsp;{{ row.item.shipping_name }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Sugestão de caixa para este frete:</b>&nbsp;{{ row.item.box_used }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Peso total dos produtos:</b>&nbsp;{{ row.item.product_weight }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Volume total dos produtos:</b>&nbsp;{{ row.item.product_volume }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Desconto de campanhas:</b>&nbsp;{{ row.item.discount_campaign }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Desconto de créditos:</b>&nbsp;{{ row.item.discount_credit }}
                      </b-row>
                      <b-row class="mb-2">
                        <b>Desconto de cupons:</b>&nbsp;{{ row.item.discount_coupon }}
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </template>
            </b-table>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <loader-box v-else height="400px" class="mr-2 mb-2 ml-2"/>
</template>

<script>
import LoaderBox from '@/components/LoaderBox.vue'
import InfoIcon from '@/components/InfoIcon.vue'

export default {
  components: {
    LoaderBox,
    InfoIcon
  },
  data: () => ({
    fields: [{
      key: 'order_id',
      label: 'Pedido'
    }, {
      key: 'order_value',
      label: 'Valor do pedido'
    }, {
      key: 'show_details',
      label: ''
    }]
  }),
  computed: {
    shipping_costs_context_loaded() { return this.$store.getters.shipping_costs_context_loaded },
    ShippingCostsObject() { return this.$store.getters.ShippingCostsObject },
  },
  methods: {
    onShippingRowDoubleClicked(item) {
      // No momento não consegui por um reverse aqui tbm
      window.open(this.$store.getters.baseUrl + '/shoppub-v2/pedidos/pedido/?q=id%3A%3D' + item.order_id, '_blank');
    }
  }
}
</script>

<style lang='scss'>
  .shipping-table-header {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-left: -8px !important;
    margin-right: -8px !important;
    margin-top: -3px !important;
  }

  #shipping-costs-table {
    tr {
      text-align-last: start;
    }
    td:not(:nth-child(3)) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
    }
    th:nth-child(1), td:nth-child(1) {
      width: 55%;
    }
    th:nth-child(3), td:nth-child(3) {
      width: 15%;
    }
    th:not(:nth-child(1)), td:not(:nth-child(1)) {
      text-align-last: right;
    }
  }

  .shipping-table-details-color {
    border: none !important;
    cursor: pointer;
  }

  #shipping-table-1 tbody tr:hover {
    color: #0BA7DA !important;
    background-color: rgba(11,167,218,.075) !important;
  }

  #shipping-table-2 tbody tr:hover {
    color: #FCBC2C !important;
    background-color: rgba(252,188,44,.075) !important
  }
</style>